import React from 'react';

const NotFound = ({
  color = '#666666',
  size = 16,
}: {
  color?: string;
  size?: number;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 96 96"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.00690343 11.7241C0.00690343 5.25711 5.27959 0.0078125 11.7738 0.0078125H84.2249C90.726 0.0078125 95.9918 5.25711 95.9918 11.7379V74.0691L79.0557 44.4996C73.7554 35.26 60.3805 35.26 55.0871 44.4996L33.4236 82.2904C32.2451 84.3207 31.6126 86.62 31.5872 88.9655C31.5618 91.311 32.1444 93.6234 33.2786 95.6786H11.7669C10.2214 95.6795 8.69088 95.3767 7.26284 94.7875C5.8348 94.1983 4.53727 93.3343 3.44443 92.2449C2.35159 91.1555 1.48488 89.862 0.893857 88.4384C0.302836 87.0149 -0.000905229 85.4891 2.02644e-06 83.9485V11.731L0.00690343 11.7241Z"
      fill="#E6E6E6"
    />
    <path
      d="M11.7687 0C5.28141 0 0.015625 5.25618 0.015625 11.7301V23.7629H96.0005V11.7232C96.0005 5.25618 90.7347 0 84.2336 0H11.7756H11.7687Z"
      fill="#999999"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M73.1899 47.9245C72.586 46.8722 71.714 45.9977 70.662 45.3895C69.61 44.7813 68.4155 44.4609 67.1995 44.4609C65.9834 44.4609 64.7889 44.7813 63.7369 45.3895C62.685 45.9977 61.8129 46.8722 61.209 47.9245L39.5455 85.7084C38.946 86.7546 38.6327 87.9393 38.6368 89.1441C38.6408 90.3489 38.9622 91.5314 39.5688 92.5735C40.1753 93.6156 41.0457 94.4806 42.0929 95.0821C43.1401 95.6835 44.3273 96.0003 45.5359 96.0007H88.8561C90.0653 96.0015 91.2534 95.6856 92.3016 95.0846C93.3497 94.4837 94.2211 93.6188 94.8284 92.5765C95.4358 91.5342 95.7578 90.3512 95.7621 89.1458C95.7665 87.9404 95.4532 86.7551 94.8534 85.7084L73.1899 47.9245Z"
      fill="#999999"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M71.5135 65.0421C71.5135 63.9017 71.059 62.808 70.2501 62.0016C69.4412 61.1952 68.3441 60.7422 67.2001 60.7422C66.0561 60.7422 64.959 61.1952 64.1501 62.0016C63.3412 62.808 62.8867 63.9017 62.8867 65.0421V71.9219C62.8867 72.4866 62.9983 73.0457 63.2151 73.5674C63.4318 74.0891 63.7495 74.5631 64.1501 74.9624C64.5506 75.3617 65.0261 75.6784 65.5494 75.8945C66.0728 76.1106 66.6337 76.2218 67.2001 76.2218C67.7665 76.2218 68.3274 76.1106 68.8508 75.8945C69.3741 75.6784 69.8496 75.3617 70.2501 74.9624C70.6507 74.5631 70.9684 74.0891 71.1852 73.5674C71.4019 73.0457 71.5135 72.4866 71.5135 71.9219V65.0421ZM67.2001 89.9814C68.3441 89.9814 69.4412 89.5284 70.2501 88.722C71.059 87.9156 71.5135 86.8219 71.5135 85.6815C71.5135 84.5411 71.059 83.4474 70.2501 82.641C69.4412 81.8347 68.3441 81.3816 67.2001 81.3816C66.0561 81.3816 64.959 81.8347 64.1501 82.641C63.3412 83.4474 62.8867 84.5411 62.8867 85.6815C62.8867 86.8219 63.3412 87.9156 64.1501 88.722C64.959 89.5284 66.0561 89.9814 67.2001 89.9814Z"
      fill="#E6E6E6"
    />
  </svg>
);

export default NotFound;
